import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Client from './tools/client';

export default {
  async getDocuments(body) {
    const url = `${process.env.EMEDIA_URL}/EmediaCDC.EXP.SearchPropertyDocuments`;
    return Client.post(url, body)
      .then((response) => {
        if (response.data.value.result === 'Success') {
          return response.data.value.detail;
        }
        throw new Error(response.data.value.result);
      })
      .catch(errorHandler);
  },

  async getCategories(body) {
    const url = `${process.env.EMEDIA_URL}/EmediaCDC.EXP.GetCategoriesAndDocumentTypes`;
    return Client.post(url, body)
      .then((response) => {
        if (response.data.value.result === 'Success') {
          return response.data.value.detail;
        }
        throw new Error(response.data.value.result);
      })
      .catch(errorHandler);
  },

  async downloadDocument(uid) {
    const url = `${process.env.EMEDIA_URL}/technical_documents/${uid}`;
    return Client.get(url, {
      responseType: 'blob',
    })
      .then((response) => response.data)
      .catch(errorHandler);
  },

  async uploadDocument(file, data) {
    const formData = new FormData();
    formData.append('metadata', JSON.stringify(data));
    formData.append('file', file);
    const url = `${process.env.EMEDIA_URL}/EmediaCDC.EXP.AddPropertyDocument`;
    return Client.post(url, formData, {
      headers: {
        'Content-Type': `multipart/form-data`,
      },
      timeout: 120 * 1000,
    })
      .then((response) => {
        if (response.data.value.result === 'Success') {
          return response.data.value.detail;
        }
        throw new Error(response.data.value.result);
      })
      .catch(errorHandler);
  },

  async deleteDocument(body) {
    const url = `${process.env.EMEDIA_URL}/EmediaCDC.EXP.DeletePropertyDocument`;
    return Client.post(url, body)
      .then((response) => {
        if (response.data.value.result === 'Success') {
          return response.data.value.detail;
        }
        throw new Error(response.data.value.result);
      })
      .catch(errorHandler);
  },

  async getRequestDocuments(body) {
    const url = `${process.env.EMEDIA_URL}/EmediaCDC.IREQ.SearchInterventionRequestDocuments`;
    return Client.post(url, body)
      .then((response) => {
        if (response.data.value.result === 'Success') {
          return response.data.value.detail;
        }
        throw new Error(response.data.value.result);
      })
      .catch(errorHandler);
  },

  async downloadRequestDocument(id) {
    const url = `${process.env.EMEDIA_URL}/intervention_request_documents/${id}`;
    return Client.get(url, {
      responseType: 'blob',
    })
      .then((response) => response.data)
      .catch(errorHandler);
  },
};
